import { useCallback } from 'react';
import { YOLO_ANNOTATION_EVENT_NAMES } from '../../../analytics/event-name';
import useAnalytics from '../../../analytics/useAnalytics';
import { EMPTY_OBJECT } from '../constants';

/**
 * @description useAnalyticsForYolo is a hook that sends events to the analytics service whenever user interacts with the yolo annotation
 * @returns {Object} - An object containing the sendEventYoloAnnotation function
 */
export const useAnalyticsForYolo = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventYoloAnnotation = useCallback(() => {
    sendEvent({
      action: YOLO_ANNOTATION_EVENT_NAMES.YOLO_BOUNDING_BOX_CLICK,
      payload: EMPTY_OBJECT
    });
  }, [sendEvent]);
  return {
    sendEventYoloAnnotation
  };
};